const PAGES = {
  ShipmentReferences: 0,
  BolReferences: 1,
  AbcdReferences: 2
};

export default PAGES;
